export const REDUCER_NAME = 'instance-detail'




// WEBPACK FOOTER //
// ./src/modules/process/state/instance-detail/const.js